<nb-toggle  [checked]="true" labelPosition="start">Message</nb-toggle>

